import { Injectable } from '@angular/core';
import { trim as _trim } from 'lodash-es';

@Injectable({
  providedIn: 'root',
})
export class PhoneNumberUtilities {
  static readonly ajsFactoryName = 'PhoneNumberUtilities';

  formatPhoneNumberString(phoneNumber: string | null | undefined): string {
    if (!phoneNumber) {
      return '';
    }

    const trimmed = _trim(phoneNumber, '()- ');
    const tenDigitPhoneNumber = trimmed.length < 10 ? '' : trimmed.substring(trimmed.length - 10, trimmed.length);
    const matches = tenDigitPhoneNumber.match(/^\d+$/g);
    if (!matches) {
      // Unknown format - return in original format
      return phoneNumber;
    }

    const formatted = trimmed.substring(0, trimmed.length - 10) +
      '(' + trimmed.substring(trimmed.length - 10, trimmed.length - 7) +
      ')' + trimmed.substring(trimmed.length - 7, trimmed.length - 4) +
      '-' + trimmed.substring(trimmed.length - 4, trimmed.length);

    return formatted;
  }
}
